<template>
  <div>
    <div :class="styles.FORM.FORM_GROUP">
      <label>
        Disable by role setting?
        <input type="checkbox" v-model="control.disableByRoleSetting">
      </label>
    </div>
    <div :class="styles.FORM.FORM_GROUP">
      <label>
        Read only?
        <input type="checkbox" v-model="control.readOnly">
      </label>
    </div>
    <div :class="styles.FORM.FORM_GROUP">
      <label>
        Has mask?
        <input type="checkbox" v-model="control.hasMask">
      </label>
      <div v-if="control.hasMask">
        <label>
          Mask format
          <p style="line-height: 0.8;">
            <code style="font-size: 8pt;">
              Usage example: ##.###-##
              <br/> #: Number (0-9)
              <br/> A: Letter in any case (a-z,A-Z)
              <br/> N: Number or letter (a-z,A-Z,0-9)
              <br/> X: Any symbol
            </code>
          </p>
        </label>
        <input type="text" :class="styles.FORM.FORM_CONTROL" v-model="control.mask">
      </div>
    </div>
  </div>
</template>

<script>
import {BaseControlConfigSkeleton} from 'v-form-builder';
import {readAdminExternalDataList} from '@/store/admin/getters';
import {dispatchGetExternalDataListAdmin} from '@/store/admin/actions';


export default {
  name: 'DatePickerConfigView',
  extends: BaseControlConfigSkeleton,
  data: () => ({
  }),
  methods: {
  },
  watch: {
    date: {
      handler(cv, ov) {
        if (!this.defaultModel) {
          const resp = this.external_data_items.filter((e) => e[this.control.field_value] === cv)[0];
          this.defaultModel = resp ? resp : null;
        }
      },
      deep: true,
    },
  },

  // async mounted() {},
};
</script>

<style scoped>

</style>
